import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { DateTime } from 'luxon';

import { FeatureFlagsConfigService } from '@olympus/ngx-shared';

import { ConfigService } from '../../services/config';

@Component({
  selector: 'app-system-info',
  templateUrl: 'system-info.component.html',
  standalone: false,
})
export class SystemInfoComponent {
  public static readonly WIDTH = '800px';
  public static readonly HEIGHT = '600px';

  public readonly VERSION: string;
  public readonly APP_NAME: string;
  public readonly TIMESTAMP: string;
  public footerMessage: string;

  constructor(
    private readonly _config: ConfigService,
    private readonly _featureFlagsConfigService: FeatureFlagsConfigService,
    @Inject(DialogRef) public dialogRef: DialogRef,
  ) {
    this.APP_NAME = this._featureFlagsConfigService.appConfig.appName;
    this.VERSION = `${this.APP_NAME}-${this._config.version.windView}-b${this._config.version.buildNumber}`;
    this.TIMESTAMP = this._config.buildTimeStamp;
    this.footerMessage = `Copyright © ${DateTime.now().toFormat('y')} Evident Corporation`;
  }
}
